<template>
    <div>
        <div :class="[
            'nt-menuvertical__item',
            { 'nt-menuvertical__item--selected': isSelected }
          ]" 
          @click="onClick(item)"
        >
            <div class="wrap-text">
                <div class="indice">{{position}}.</div>
                <div class="text">{{item.text}}</div>
                <div :class="[{ 'icon--opened': isOpened }, 'icon']" v-if="item.childrens" @click.stop="onClickDrop"></div>
            </div>
            <div class="arrow"></div>
        </div>
        <ul v-if="item.childrens && isOpened">
            <li v-for="(children, index) in item.childrens" v-bind:key="children.id">
              <nt-vertical-menu-item :item="children" :position="++index" :selected="selected"></nt-vertical-menu-item>
            </li>
        </ul>
    </div>
</template>

<script>
  export default {
    name: 'NtVerticalMenuItem',
    props: {
      item: {
        type: Object,
        default: null
      },
      position: {
        type: Number
      },
      selected: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        opened: false
      }
    },
    computed: {
      isOpened() {
        return this.opened
      },
      isSelected() {
        return this.selected === this.item
      }
    },
    methods: {
      onClick(item) {
        this.$root.$emit('changeVerticalMenu', item)

        const { href } = item
        document.location.href = href
      },
      onClickDrop() {
        this.opened = !this.opened
        window.console.log('xxxx')
      }
    }
  }
</script>
